export const Boton = ({ children, onClick, icon: Icon }) => (
  <button
    onClick={onClick}
    className="rounded-metric bg-metric-blue-700 hover:bg-metric-blue-800 flex w-full items-center justify-center gap-2 px-6 py-3 font-semibold text-white transition-all active:scale-[0.98]"
  >
    {Icon && <Icon size={20} />}
    {children}
  </button>
);
